import script from "./kalio-office-hour-offering-new.vue?vue&type=script&setup=true&lang=ts"
export * from "./kalio-office-hour-offering-new.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__